'use strict';
import * as $j_app$002edata$002etypes$005fgeneral$005fpractice$005fuser$0024package$0024$002dGeneral$002dPractice$002dUser$002dId$0024 from "./app.data.types_general_practice_user$package$-General-Practice-User-Id$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$5() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$5 as $c_Lapp_data_AppRegisteredUser$$anon$5 };
$c_Lapp_data_AppRegisteredUser$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$5.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$5;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$5() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$5 as $h_Lapp_data_AppRegisteredUser$$anon$5 };
$h_Lapp_data_AppRegisteredUser$$anon$5.prototype = $c_Lapp_data_AppRegisteredUser$$anon$5.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$5.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$5.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy4 = $j_app$002edata$002etypes$005fgeneral$005fpractice$005fuser$0024package$0024$002dGeneral$002dPractice$002dUser$002dId$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice\uff3fuser$package$GeneralPracticeUserId$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForUUID);
});
$c_Lapp_data_AppRegisteredUser$$anon$5.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_data_AppRegisteredUser$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$5, "app.data.AppRegisteredUser$$anon$5", ({
  Lapp_data_AppRegisteredUser$$anon$5: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$5 as $d_Lapp_data_AppRegisteredUser$$anon$5 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$5.js.map
